define(["data/config"], function(config) {
    var apply = function($element, params) {
        $element.append(
            '<div class="c_feedbackMessage-close"><a><i class="fas fa-times"></i></a></div>'
        );

        $element.on(
            "click",
            ".c_feedbackMessage-close",
            function() {
                $element.addClass('c_feedbackMessage-closing');
                setTimeout(function() {
                    $element.addClass('u_hidden');
                }, 600);    // 600ms is the same 0.6s on c_feedbackMessage-closing animation
            }
        );
    };

    return {
        name: "feedbackMessage",
        apply: apply
    };
});
